import request from '@/utils/request';

/**
 * 菜单
 * @param pram
 */
export function menuListApi() {
  return request({
    // 淘客后台的菜单是 type=10 那套，必须走淘客端接口；
    // 商户端的 getMenus 返回的是 type=4 商户菜单，侧边栏就没有淘客页面
    url: '/admin/distribution/getMenus',
    method: 'GET'
  });
}